import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueAnalytics from 'vue-analytics'
import "material-design-icons-iconfont/dist/material-design-icons.css";
// services
import ApiService from "./common/api.service";
import { USER } from "@/store/actions.type";

Vue.config.productionTip = false;

// Setting global
ApiService.init();

Vue.use(VueAnalytics, {
  id: 'G-SF2KDBJ6JF',
  router,
  debug: {
    enabled: false, // default value
    trace: false, // default value
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})
new Vue({
  router,
  store,
  vuetify,
  created() {
    store.dispatch(USER.AUTH)
  },
  render: h => h(App)
}).$mount("#app");
